export default function PageHeader({
  en,
  title,
  description,
}: {
  en: string;
  title: string;
  description?: string;
}) {
  return (
    <section className="bg-white px-3 pt-3 sm:px-5">
      <div className="relative overflow-hidden rounded-[32px] bg-forest text-white">
        <div
          className="pointer-events-none absolute inset-0 opacity-25"
          style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,.55) 1.2px, transparent 1.4px)', backgroundSize: '22px 22px' }}
          aria-hidden
        />
        <div className="pointer-events-none absolute -right-16 -top-20 h-72 w-72 rounded-full bg-sun" aria-hidden />
        <div className="pointer-events-none absolute -bottom-28 right-40 h-56 w-56 rounded-full bg-forest-600" aria-hidden />
        <div className="wrap relative pb-14 pt-14 sm:pb-20 sm:pt-20">
          <span className="inline-flex rounded-full bg-white/15 px-3.5 py-1.5 font-serif text-sm font-extrabold tracking-wide backdrop-blur">
            {en}
          </span>
          <h1 className="mt-5 text-[40px] font-extrabold leading-[1.15] tracking-[-0.035em] sm:text-6xl">{title}</h1>
          {description && <p className="mt-5 max-w-xl text-lg text-white/75">{description}</p>}
        </div>
      </div>
    </section>
  );
}
